// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/BlogDetails.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/BlogDetails.tsx");
  import.meta.hot.lastModified = "1716289823159.0903";
}
// REMIX HMR END

import { format } from "date-fns";
export default function BlogDetails({
  created
}) {
  return <>
      <span className="text-gray-600">{format(created, "do LLL, yyyy")}</span>
    </>;
}
_c = BlogDetails;
var _c;
$RefreshReg$(_c, "BlogDetails");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;